import { render, staticRenderFns } from "./MatchTypeColumnContentForm.vue?vue&type=template&id=bb268334"
import script from "./MatchTypeColumnContentForm.vue?vue&type=script&lang=js"
export * from "./MatchTypeColumnContentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports